import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Skill, Translation } from 'src/models/models';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class TranslationService extends BaseService<Translation, Translation> {

  constructor(protected override http: HttpClient) {
    super(http, 'translations');
  }
}
